import React, { Component } from "react";
import CommunicationPage from "../Images/communication_intro.jpg";

class Communication extends Component {
  state = {};
  render() {
    return (
      <div className="container">
        <img className="img-fluid" src={CommunicationPage} alt="Founders" />
        <h1 className="pag-header head text-center">
          Clinical Support to Families and Persons With Communication Disorders
          and Dyslexia
        </h1>
        <h3>Purpose</h3>
        <p>
          To provide technical skills and strategies that Families and Persons
          with Communication Disorders and Dyslexia need so as to function
          according to standard as peers in an Inclusive Educational setting
          within a short period.
        </p>
        <h3>Communication Disorders</h3>
        <ul>
          <li>Children with Speech and Language Disorders.</li>
          <li>Case History.</li>
          <li>Identification of child’s problems.</li>
          <li>Diagnostic Assessment.</li>
          <li>Management of child.</li>
          <li>Therapy Sessions.</li>
          <li>Referrals if possible.</li>
          <li>Parental/Siblings Counselling on Managing child.</li>
          <li>Individual/ Group of Parents Meeting.</li>
        </ul>
        <h3>Struggling Reading-Dyslexia</h3>
        <p>Methods to use for struggling children in Reading;</p>
        <ul>
          <li>Phonemic Awareness.</li>
          <li>Phonic System.</li>
          <li>Sight words (look and say method).</li>
          <li>
            Sight word Recognition of Winneba List of 100 High Frequency words.
          </li>
          <li>Word/Sentence Method.</li>
          <li>LRS method.</li>
          <li>Language Experience Approach.</li>
          <li>ABA- Evidence Based Teaching Strategies.</li>
        </ul>
        <h3> Identifying Struggling Readers</h3>
        <ul>
          <li>Using checklists/standardized instruments.</li>
          <li>Diagnostic assessment.</li>
          <li>Management/referrals</li>
          <li>
            Writing difficulties (writer’s cramp, cerebral handedness and its
            implications).
          </li>
          <li> Managements.</li>
        </ul>
        <div className="text-center">
          <iframe
            width="873"
            height="480"
            src="https://www.youtube.com/embed/un1bzYamNbk"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    );
  }
}

export default Communication;
